import React from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export default function ImageViewerDialog({ imageViewer, setImageViewer }) {
	return (
		<Dialog
			open={imageViewer.open}
			onClose={() => setImageViewer({ open: false, url: '', title: '' })}
			fullWidth
			maxWidth='md'>
			<DialogTitle>{imageViewer.title || 'Ảnh đối soát'}</DialogTitle>
			<DialogContent dividers sx={{ display: 'flex', justifyContent: 'center', background: '#111' }}>
				{imageViewer.url && (
					<Box
						component='img'
						src={imageViewer.url}
						alt={imageViewer.title || 'Ảnh đối soát'}
						sx={{
							maxWidth: '100%',
							maxHeight: '75vh',
							objectFit: 'contain',
						}}
					/>
				)}
			</DialogContent>
			<DialogActions>
				<Button startIcon={<CloseIcon />} onClick={() => setImageViewer({ open: false, url: '', title: '' })}>
					Đóng
				</Button>
			</DialogActions>
		</Dialog>
	)
}
